"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthcareParty = void 0;
/**
 * This entity is a root level object. It represents a healthcare party. It is serialized in JSON and saved in the underlying icure-healthcareParty CouchDB database.
 */
const ModelHelper_1 = require("./ModelHelper");
class HealthcareParty {
    constructor(json) {
        Object.assign(this, json, json.picture ? { picture: ModelHelper_1.b64_2ab(json.picture) } : {});
    }
}
exports.HealthcareParty = HealthcareParty;
(function (HealthcareParty) {
    HealthcareParty.GenderEnum = {
        Male: 'male',
        Female: 'female',
        Indeterminate: 'indeterminate',
        Changed: 'changed',
        ChangedToMale: 'changedToMale',
        ChangedToFemale: 'changedToFemale',
        Unknown: 'unknown',
    };
    HealthcareParty.StatusesEnum = {
        Trainee: 'trainee',
        Withconvention: 'withconvention',
        Accreditated: 'accreditated',
    };
})(HealthcareParty = exports.HealthcareParty || (exports.HealthcareParty = {}));
//# sourceMappingURL=HealthcareParty.js.map